import * as z from 'zod/v4';

const backendErrorSchema = z.object({
  code: z.number(),
  requestId: z.string(),
  message: z.string().transform((message) => {
    try {
      return decodeURIComponent(message);
    } catch {
      return message;
    }
  }),
  supportUrl: z.string(),
  category: z
    .enum(['BadMessageFormat', 'NotAuthenticated', 'NotAuthorized', 'InvalidRequest', 'ResourceNotFound'])
    // this is our fallback in case of a new error code is added in API
    .or(z.literal('UNKNOWN'))
    .catch('UNKNOWN'),
});

export type ApiErrorResponse = z.infer<typeof backendErrorSchema>;

/**
 * Zod schema for API error response
 */
export const apiErrorSchema = z.object({
  error: backendErrorSchema,
  elapsedTime: z.number(),
});
